import { AfterViewInit, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ClevertapEvent } from 'src/app/analytics/clevertap/enum/clevertap.eventType';
import { ClevertapService } from 'src/app/analytics/clevertap/service/clevertap.service';
import { AppEventName } from 'src/app/analytics/newrelic/enums/EventName';
import { NewrelicService } from 'src/app/analytics/newrelic/services/newrelic.service';
import { NewrelicAppStore } from 'src/app/analytics/newrelic/store/newrelicApp.store';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { EntitlementService } from 'src/app/shared/services/evergent/entitlement/entitlement.service';
import { GeoLocationService } from 'src/app/shared/services/geolocation.service';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
import { RouteHistoryService } from 'src/app/shared/services/router-history.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { TvodPaymentNotAllowedComponent } from '../../subscription-alerts/tvod-payment-not-allowed/tvod-payment-not-allowed.component';

@Component({
  selector: 'app-rent-to-watch',
  templateUrl: './rent-to-watch.component.html',
  styleUrls: ['./rent-to-watch.component.scss'],
})
export class RentToWatchComponent implements AfterViewInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly newrelic: NewrelicService,
    private readonly newrelicStore: NewrelicAppStore,
    private readonly router: Router,
    private readonly dialogService: DialogService,
    private readonly authService: AuthService,
    private readonly navService: NavigationLibraryService,
    private readonly geoLocationService: GeoLocationService,
    private readonly entitlementService: EntitlementService,
    private readonly toast: ToastService,
    private readonly clevertapService: ClevertapService,
    private readonly routeHistoryService: RouteHistoryService
  ) {}

  ngAfterViewInit(): void {
    this.navService.focusContainer('rent-to-watch-actions', true, 0, true);
  }

  rentNowAction() {
    // Need to work on this flow
    if (!this.authService.isLoggedIn()) {
      this.dialogService.close({
        navigationPath: 'link-tv',
        data: {
          validateTvodPurchase: true,
          redirectFrom: this.data.redirectFrom,
        },
      });
    } else {
      this.dialogService.close();
      if (
        this.geoLocationService.isFromIndia() &&
        this.geoLocationService.isChannelPartnerValid()
      ) {
        const skuIds = this.data.resource.tvodPurchaseConfiguration.sku;
        const isValidSku = this.entitlementService.tvodCatalog.find((catalog) =>
          skuIds.includes(catalog.skuORQuickCode)
        );
        if (isValidSku) {
          this.router.navigate(['tv-payments'], {
            state: {
              isTvod: true,
              resource: this.data.resource,
              redirectFrom: this.data.redirectFrom,
            },
          });
        } else {
          this.toast.error('Catalog or Product ID not found');
        }
      } else {
        if (!this.geoLocationService.isChannelPartnerValid()) {
          this.dialogService.openDialog(TvodPaymentNotAllowedComponent);
        } else {
          this.router.navigate(['rent-now']);
        }
      }
      this.newrelic.sendAppEvent(AppEventName.RENT_CONTENT, {
        ...this.newrelicStore.getRentContentInfo(
          this.data.resource,
          this.data.priceCode
        ),
      });
      this.clevertapService.addEvent(ClevertapEvent.CLICKED_WATCH_ON_RENT, {
        resource: this.data.resource,
      });
    }
  }

  cancelAction() {
    if (this.data.redirectFrom === 'player') {
      this.routeHistoryService.goBack();
    }
    this.dialogService.close();
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      this.disabled(event);
    }
  }

  disabled(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
